import "./Footer.css"

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-content">
      <p>© 2024</p>
      <p>By Lucie Jagošová</p>
      </div>
    </div>
  )
}

export default Footer